import { createContext, useContext } from 'react';

interface IAdminContext {
  /** Returns `true` if the company is paying by credit card. */
  isCreditCardCompany: boolean;

  /** Returns `true` if the company is a Freemium company. */
  isFreemiumCompany: boolean;

  /** Returns `true` if the company is paying by invoice. */
  isInvoiceCompany: boolean;

  /** Returns `true` if the company is self-serve annual. */
  isSelfServeAnnualCompany: boolean;
}

export const useAdminContext = () => useContext(AdminContext);

export const AdminContext = createContext<IAdminContext>({
  isCreditCardCompany: false,
  isFreemiumCompany: false,
  isInvoiceCompany: false,
  isSelfServeAnnualCompany: false,
});
